import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import moment from 'moment'

import SmartLink from '../../SmartLink'

import timeIcon from '../images/time.svg'

const RootContainer = styled(SmartLink)`
	color: black;
	
	&:hover {
		text-decoration: none;
	}
	&:hover .readMore {
		text-decoration: underline;
	}
`

const Title = styled.div`
	font-size: ${props => props.theme.fontSizes.big20};
	font-weight: ${props => props.theme.fontWeights.bold};
`

const Excerpt = styled.div`
	font-size: ${props => props.theme.fontSizes.small};
	font-weight: ${props => props.theme.fontWeights.regular};
	margin: 1.3rem 0 1.875rem;
`

const PublishedAtAndReadMore = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: baseline;
`

const PublishedAtIcon = styled.img`
	margin-right: .6rem;
	margin-bottom: 0;
`

PublishedAtIcon.defaultProps = {
	src: timeIcon,
	alt: '',
}

const PublishedAt = styled.div`
	font-weight: ${props => props.theme.fontWeights.regular};
	color: ${props => props.theme.colors.grayText};
	font-size: ${props => props.theme.fontSizes.extraSmall};
	display: flex;
	align-items: center;
`

const ReadMore = styled.div`
	font-weight: ${props => props.theme.fontWeights.regular};
	color: ${props => props.theme.colors.main};
	font-size: ${props => props.theme.fontSizes.small};
`
ReadMore.defaultProps = {
	className: 'readMore',
}

const OneItem = ({data, className}) => <RootContainer className={className} to={data.link}>
	<Title>{data.title}</Title>
	<Excerpt>{data.excerpt}</Excerpt>
	<PublishedAtAndReadMore>
		<PublishedAt><PublishedAtIcon/>{moment(data.createdAt).fromNow()}</PublishedAt>
		<ReadMore>Read more →</ReadMore>{/* TODO move to translations */}
	</PublishedAtAndReadMore>
</RootContainer>

OneItem.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		excerpt: PropTypes.string.isRequired,
		createdAt: PropTypes.string.isRequired,
		link: PropTypes.string.isRequired,
	}).isRequired,
}
OneItem.defaultProps = {
	className: '',
}

export default OneItem
